module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre_15",
    attrs: {
      "id": "calibre_pb_22"
    }
  }, [_c('span', {
    staticClass: "calibre10"
  }, [_vm._v("TIME AND SPACE")])]), _vm._v(" "), _c('h2', {
    staticClass: "calibre_22",
    attrs: {
      "id": "filepos65673"
    }
  }, [_c('span', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "italic1"
  }, [_vm._v("4 "), _c('img', {
    staticClass: "calibre11",
    attrs: {
      "alt": "image",
      "src": "images/00004.jpg"
    }
  }), _vm._v(" Time and Movement Are Two Aspects of a Single Phenomenon")])])]), _c('div', {
    staticClass: "calibre_14"
  }), _vm._v(" "), _c('h3', {
    staticClass: "calibre_23",
    attrs: {
      "id": "filepos65875"
    }
  }, [_c('span', {
    staticClass: "calibre12"
  }, [_c('span', {
    staticClass: "italic1"
  }, [_vm._v("Portrait of a Gentleman")])])]), _c('div', {
    staticClass: "calibre_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("We are vortices whose centre is a point that is motionless and eternal but which appears in manifestation as motion which increases in velocity in the manner of a whirlpool or "), _c('a'), _vm._v("tornado (whose epicentre is still) from nucleus to periphery.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("But the nucleus is in Reality, whereas the vortex is phenomenon in the form of a multi-dimensional force-field.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("The periphery of this force-field appears as matter, of various densities, extended in space and moving in time at divers velocities.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("The totality of this appearance partakes of the consciousness which is its core and only reality.")])]), _vm._v(" "), _c('div', {
    staticClass: "mbp_pagebreak",
    attrs: {
      "id": "calibre_pb_23"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2ad122a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_014.vue
// module id = 102
// module chunks = 0